import React from 'react';

export interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
}

export const Checkbox: React.FC<CheckboxProps> = ({ 
  label,
  className = '', 
  ...props 
}) => {
  return (
    <div className="flex items-center space-x-2">
      <input 
        type="checkbox"
        className={`h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 rounded ${className}`} 
        {...props}
      />
      {label && (
        <label className="text-sm text-gray-700">
          {label}
        </label>
      )}
    </div>
  );
};
